import React from 'react';
import './BurgerButton.css';

export type BurgerButtonProps = {
  open: boolean;
  onClick: () => void;
  controlsId: string;
  className?: string;
  labelOpen?: string;
  labelClosed?: string;
};

const BurgerButton: React.FC<BurgerButtonProps> = ({
  open,
  onClick,
  controlsId,
  className = '',
  labelOpen = 'Close menu',
  labelClosed = 'Open menu',
}) => (
  <button
    type="button"
    className={['burger-button', open ? 'burger-button--open' : '', className]
      .filter(Boolean)
      .join(' ')}
    aria-label={open ? labelOpen : labelClosed}
    aria-expanded={open}
    aria-controls={controlsId}
    onClick={onClick}
  >
    <span className="burger-button__bar" />
    <span className="burger-button__bar" />
    <span className="burger-button__bar" />
  </button>
);

export default BurgerButton;
